import React, {useEffect, useState} from "react";
import {Business, CardTransaction, CurrentUser, UserCard} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";
import "./../../App.css"
import "./WalletPage.css"
import {useNavigate} from "react-router";
import TransactionList from "../../components/transaction/TransactionList";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import PointsCardV2 from "../../components/card/PointsCardV2";
import LoadingWheel from "../../components/loading/LoadingWheel";
import InfoAlert from "../../components/info/InfoAlert";

interface Props {
  currentUser: CurrentUser;
  businessMap: Map<string, Business>;
  userCardsMap: Map<string, UserCard>;
}

function WalletPage(props: Props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [transactions, setTransactions] = useState<Array<CardTransaction>>([]);
  const cards = Array.from(props.userCardsMap.values())
      .filter(card => card.status == "ACTIVE")
      .sort((a, b) => b.points - a.points);

  useEffect(() => {
    if(props.currentUser.userType !== "CUSTOMER") {
      navigate("/scan")
    }
  });

  useEffect(() => {(async () => {
    let transactions = new Array<CardTransaction>();
    const transactionsCollection = query(
        collection(db, 'transactions'),
        where("user", "==", props.currentUser.id),
        orderBy("createdAt", "desc"),
        limit(1000),
    );
    const transactionsSnapshot = await getDocs(transactionsCollection);
    transactionsSnapshot.forEach((doc) => {
      transactions.push(doc.data() as CardTransaction);
    });
    setTransactions(transactions);
    setLoading(false);
  })();
  }, []);

  return (
      <>
        <AuthCheck />
        {props.currentUser.userType === "CUSTOMER" && <div>
          {loading && <div className={"mt-3"}>
              <InfoAlert message={"Loading your cards..."}/>
              <div className={"centre-align mt-3"}>
                <LoadingWheel />
              </div>
          </div>}
          {(cards && !loading && cards.length === 0) && <div className={"basic-box mb-0 left-align"}>Visit a location to create your first card.</div>}
          {/*{(cards && cards.length > 0) && <InfoAlert message={"Tap a card below to see more details."}/>}*/}
          {(cards && !loading && cards.length > 0) && <>
              <div className={"centre-align"}>
                {cards.map((card, index) => (
                    <div
                        className={`d-inline-block me-1 mt-1 cursor-pointer ${index === cards.length - 1 ? 'mb-1' : 'mb-2 F'}`}
                        onClick={() => navigate(`/card/${card.id}`)}>
                      <PointsCardV2 user={props.currentUser} pointsCard={card}
                                  business={props.businessMap.get(card.business)}/>
                    </div>
                ))}
            </div>
            <TransactionList transactions={transactions} businessMap={props.businessMap} defaultDisplayList={false} />
          </>}
        </div>}
      </>
  );
};

export default WalletPage;
